export const request = {
    "Streaming": "movie/top_rated",
    "On TV":     "tv/popular",    
    "For Rent":  "movie/upcoming",
    "In Theaters": "movie/popular",
    "Today": "tv/airing_today",
    "This Week": "tv/on_the_air",
    "Movies": "discover/movie",
    "TV": "discover/tv"
}
